import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["container", "id", "name", "disabled", "visible", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createElementBlock("span", {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.HtmlTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.HtmlTypeConst.STYLE)),
        class: _normalizeClass({ [_ctx.getPropertyValue(_ctx.HtmlTypeConst.CLASS) ?? '']: true, 'customrequired': _ctx.getPropertyBooleanValue(_ctx.HtmlTypeConst.REQUIRED) }),
        name: _ctx.getPropertyValue(_ctx.HtmlTypeConst.NAME),
        disabled: _ctx.getPropertyBooleanValue(_ctx.HtmlTypeConst.DISABLED),
        visible: _ctx.getPropertyBooleanValue(_ctx.HtmlTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.HtmlTypeConst.PLACEHOLDER)
      }, [
        _renderSlot(_ctx.$slots, "content"),
        _createTextVNode(" " + _toDisplayString(_ctx.getPropertyValue(_ctx.HtmlTypeConst.TEXT)) + " " + _toDisplayString(_ctx.vmodel), 1 /* TEXT */)
      ], 14 /* CLASS, STYLE, PROPS */, _hoisted_1)), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.HtmlTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}